const initialState = {
  products: [
    // {
    //   product_id: 0,
    //   title: "",
    //   category: "",
    //   url: "",
    //   quantity: 0,
    //   price: 0,
    // },
  ],
  cart: [
    // {
    //   cart_id: 0,
    //   title: "",
    //   category: "",
    //   price: 0,
    //   quantity: 0
    // },
  ],
};

export default initialState;
